// const jumpInWarehouse = (tokens,names,ids,taskType) => {
//     let url = '';
//     if (taskType === 'in') {
//         url = process.env.VUE_APP_BASE_HTML + '#/inWarehouse';
//     } else if (taskType === 'out') {
//         url = process.env.VUE_APP_BASE_HTML + '#/outbound';
//     } else {
//         console.error('未知的任务类型');
//         return false;
//     }
//     const openedWindowsBoolean = localStorage.getItem('openedWindowsBoolean') ? JSON.parse(localStorage.getItem('openedWindowsBoolean').toLowerCase()) : true 
//     // true是可以打开新窗口，false是已经有打开的新窗口
//     // 如果是新建操作（id为add），新建和查看详情不管什么类型，一次都只能打开一个
//     const windowKey = ids === 'add' ? `${taskType}_add` : `${taskType}_${ids}`;
//     // 从本地存储中获取打开窗口信息
//     // 检查窗口是否已打开
//     if (!openedWindowsBoolean) { // 有窗口打开
//         this.$message.error('已有打开窗口');
//         return false;
//     }
//     // 生成唯一的窗口标识
//     const uniqueWindowKey = `PopupWindow_${windowKey}_${Date.now()}`;
//     const timestamp = Date.now();
//     const uniqueUrl = `${url}?timestamp=${timestamp}&id=${ids}&type=${taskType}`;
//     const popup = window.open(
//         uniqueUrl,
//         uniqueWindowKey,
//         'width=1860,height=870,top=60,resizable=yes,scrollbars=yes'
//     );
//     if (!popup) {
//         this.$message.error('弹窗被阻止！');
//         return false;
//     }
//     // 记录打开的窗口信息
//     this.openedWindows = {
//         popup: popup,
//         key: uniqueWindowKey,
//         taskType: taskType,
//         taskId: ids === 'add' ? null : ids,
//         isAdd: ids === 'add',
//         lastActive: Date.now()
//     }
//     localStorage.setItem('openedWindowsBoolean', false);

//     // 窗口关闭检测定时器（始终运行，直到窗口关闭）
//     const windowCloseChecker = setInterval(() => {
//         if (popup.closed) {
//             clearInterval(windowCloseChecker);
//             clearInterval(messageSender); // 也清除消息发送器
            
//             // 清理本地存储和状态
//             localStorage.setItem('openedWindowsBoolean', true);
//             this.openedWindows = {};
            
//             // 刷新父页面列表
//             this.getTaskList();
//             return;
//         }
//     }, 500);
//     let tokenReceived = false; // 标记是否收到确认信息
//     // 消息发送定时器（只在未收到确认时发送）
//     const messageSender = setInterval(() => {
//         if(!tokenReceived){
//             try {
//                 popup.postMessage(
//                     { 
//                         type: 'SET_TOKEN', 
//                         token: tokens,
//                         name: names,
//                         id: ids === 'add' ? '' : ids,
//                     },
//                     process.env.VUE_APP_BASE_HTML
//                 );
//             } catch (e) {
//                 // 忽略跨域错误
//             }
//         }else{
//             // 收到确认后停止发送
//             clearInterval(messageSender);
//         }
        
//     }, 500);
//     // 监听子窗口的确认消息
//     const messageHandler = (event) => {
//         if (event.data.type === 'TOKEN_RECEIVED') {
//             tokenReceived = true; // 标记已收到确认
//             clearInterval(messageSender);  // 收到确认后停止发送
//             window.removeEventListener('message', messageHandler);  // 移除事件监听
//         }
//     };
//     window.addEventListener('message', messageHandler);
//     return true;
// }
// // 导出函数供其他模块使用
// export { jumpInWarehouse };
// src/config/jumpInWarehouse.js
const jumpInWarehouse = (component, tokens, names, ids, taskType) => {
    let url = '';
    if (taskType === 'in') {
        url = process.env.VUE_APP_BASE_HTML + '#/inWarehouse';
    } else if (taskType === 'out') {
        url = process.env.VUE_APP_BASE_HTML + '#/outbound';
    } else if(taskType === 'move') {
        url = process.env.VUE_APP_BASE_HTML + '#/inventoryMove';
    } else{
        component.$message.error('未知的任务类型');
        return false;
    }
    // // 检查是否已有窗口打开
    // const activeWindowKey = sessionStorage.getItem('activePopupWindow');
    // if (activeWindowKey) {
    //     try {
    //         // 尝试检查窗口是否还存在
    //         const testWindow = window.open('', activeWindowKey);
    //         if (testWindow && !testWindow.closed) {
    //             component.$message.error('已有打开窗口');
    //             return false;
    //         }
    //     } catch (e) {
    //         // 窗口不存在，清除sessionStorage中的记录
    //         sessionStorage.removeItem('activePopupWindow');
    //     }
    // }
    
    // if (popup) {
    //     // 存储当前活动窗口的key
    //     sessionStorage.setItem('activePopupWindow', uniqueWindowKey);
    // }
    
    // // 窗口关闭时清理
    // const windowCloseChecker = setInterval(() => {
    //     if (popup.closed) {
    //         clearInterval(windowCloseChecker);
    //         sessionStorage.removeItem('activePopupWindow');
    //         // ... 其他清理逻辑 ...
    //     }
    // }, 500);


    const openedWindowsBoolean = localStorage.getItem('openedWindowsBoolean') 
        ? JSON.parse(localStorage.getItem('openedWindowsBoolean').toLowerCase()) 
        : true;
    
    const windowKey = ids === 'add' ? `${taskType}_add` : `${taskType}_${ids}`;
    
    if (!openedWindowsBoolean) {
        component.$message.error('已有打开窗口');
        return false;
    }
    
    const uniqueWindowKey = `PopupWindow_${windowKey}_${Date.now()}`;
    const timestamp = Date.now();
    const uniqueUrl = `${url}?timestamp=${timestamp}&id=${ids}&type=${taskType}`;
    
    const popup = window.open(
        uniqueUrl,
        uniqueWindowKey,
        'width=1860,height=870,top=60,resizable=yes,scrollbars=yes'
    );
    
    if (!popup) {
        component.$message.error('弹窗被阻止！');
        return false;
    }
    
    // 记录打开的窗口信息到组件实例
    component.openedWindows = {
        popup: popup,
        key: uniqueWindowKey,
        taskType: taskType,
        taskId: ids === 'add' ? null : ids,
        isAdd: ids === 'add',
        lastActive: Date.now()
    };
    
    localStorage.setItem('openedWindowsBoolean', false);

    // 窗口关闭检测定时器
    const windowCloseChecker = setInterval(() => {
        if (popup.closed) {
            clearInterval(windowCloseChecker);
            clearInterval(messageSender);
            window.removeEventListener('message', messageHandler);
            
            localStorage.setItem('openedWindowsBoolean', true);
            component.openedWindows = {};
            
            // 调用组件的刷新方法
            if (component.getTaskList) {
                component.getTaskList();
            }
            return;
        }
    }, 500);
    
    let tokenReceived = false;
    
    const messageSender = setInterval(() => {
        if (!tokenReceived) {
            try {
                popup.postMessage(
                    { 
                        type: 'SET_TOKEN', 
                        token: tokens,
                        name: names,
                        id: ids === 'add' ? '' : ids,
                    },
                    process.env.VUE_APP_BASE_HTML
                );
            } catch (e) {
                // 忽略跨域错误
            }
        } else {
            clearInterval(messageSender);
        }
    }, 500);
    // 在 messageHandler 中添加
    const messageHandler = (event) => {
        if (event.data.type === 'TOKEN_RECEIVED') {
            tokenReceived = true;
            clearInterval(messageSender);
        }
        if (event.data.type === 'WINDOW_CLOSED') {
            clearInterval(windowCloseChecker);
            clearInterval(messageSender);
            localStorage.setItem('openedWindowsBoolean', true);
            component.openedWindows = {};
            if (component.getTaskList) {
                component.getTaskList();
            }
        }
    };
    // const messageHandler = (event) => {
    //     if (event.data.type === 'TOKEN_RECEIVED') {
    //         tokenReceived = true;
    //         clearInterval(messageSender);
    //         window.removeEventListener('message', messageHandler);
    //     }
    // };
    
    window.addEventListener('message', messageHandler);
    return true;
};

export { jumpInWarehouse };